import { Button } from '@repo/ui/button'
import { useAsyncData } from '@repo/ui/dataProvider'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/dialog'
import { useT } from '@repo/ui/hooks'
import { InlineCode } from '@repo/ui/inlineCode'
import { Input } from '@repo/ui/input'
import { Label } from '@repo/ui/label'
import { onInput } from '@repo/ui/utils'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { ReadonlyFilterList } from '@/components/beneficiary/list/filters/ReadonlyFilterList'
import { selectCurrentFilters, selectSearchText } from '@/store/beneficiary-list-filters/selectors'
import { createFilterTemplate } from '@/store/beneficiary-list-filters/thunks'
import { getCurrentOrganization } from '@/store/helpers'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function FilterTemplateCreator({
  modalHandler,
}: {
  modalHandler: { open: boolean; setOpen: (open: boolean) => void }
}) {
  const dispatch = useStoreDispatch()
  const {
    data: [organization],
  } = useAsyncData([getCurrentOrganization])

  const schema = organization?.structuredDataSchema || []

  const [name, setName] = useState('')
  const { tc } = useT()

  const filters = useSelector(selectCurrentFilters)

  const searchText = useSelector(selectSearchText)

  const beneficiaryCount = useStoreState((state) => state.beneficiaryList.pagination.totalItems)
  const handleCreate = () => {
    void dispatch(
      createFilterTemplate({
        name,
        filters,
      }),
    )
    modalHandler.setOpen(false)
  }
  return (
    <Dialog
      open={modalHandler.open}
      defaultOpen={modalHandler.open}
      onOpenChange={modalHandler.setOpen}
      modal
    >
      <DialogContent className="max-h-[75vh]">
        <DialogHeader>
          <DialogTitle>{tc('create', { cfl: true })}</DialogTitle>
          <DialogDescription>{tc('filterTemplate', { cfl: true, colon: true })}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <Label>{tc('name', { cfl: true, colon: true })}</Label>
            <Input
              value={name}
              placeholder={tc('name', { cfl: true })}
              onChange={onInput(setName)}
            />
          </div>

          <div className="flex flex-col gap-4 border-t-4 border-primary-50 pt-4">
            <Label className="text-base">{tc('filters', { cfl: true })}</Label>

            {searchText && (
              <div className="flex flex-col gap-1">
                <Label>{tc('searchTerm', { cfl: true, colon: true })}</Label>
                <InlineCode className="select-none">{searchText}</InlineCode>
              </div>
            )}

            <ReadonlyFilterList filters={filters} schema={schema} />
          </div>

          <div className="flex flex-col gap-4 border-t-4 border-primary-50 pt-4">
            <Label className="text-base">{tc('result', { cfl: true })}</Label>

            <div className="flex flex-col gap-1">
              <InlineCode className="select-none">
                {tc('beneficiary', { count: beneficiaryCount, cfl: true })}
              </InlineCode>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={handleCreate}>{tc('create', { cfl: true })}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
